module.exports = __webpack_public_path__ + "static/img/mtjj.9975927.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/mtjj.webp
// module id = vLAb
// module chunks = 68